import { observer } from 'mobx-react-lite'
import { usePostHog } from 'posthog-js/react'
import { useEffect } from 'react'

import { useGlobalState } from '@/hooks/useGlobalState'

/**
 * Identifies the signed-in user to PostHog.
 *
 * Has to render inside PostHogProvider, since usePostHog resolves the client from context. This used
 * to run inside the /auth route's render condition, which fired it during render and only on that
 * one route.
 */
export const PostHogIdentify = observer(function PostHogIdentify() {
  const posthog = usePostHog()
  const { authenticationStore } = useGlobalState()
  const { user } = authenticationStore

  const userId = user?.userId
  const isSponsor = user?.isSponsor
  const isSponsorAdmin = user?.isSponsorAdmin
  const sponsorId = user?.sponsorId
  const sponsorName = user?.sponsorName

  useEffect(() => {
    if (!posthog || !userId) return
    posthog.identify(userId, { isSponsor, isSponsorAdmin, sponsorId, sponsorName })
  }, [posthog, userId, isSponsor, isSponsorAdmin, sponsorId, sponsorName])

  return null
})
